export type WriterNodeEvent = CustomEvent<{
  content: string;
  selectedText?: string | null;
  isSelectedPart?: boolean;
}>;

export const EVENT_TYPES = {
  WRITER_NODE_CONTENT: 'writer-node-content',
  WRITER_NODE_COMPLETE: 'writer-node-complete',
  SHOW_AI_RESPONSE_HANDLER: 'show-ai-response-handler',
  TRIGGER_AI_RESPONSE_HANDLER: 'trigger-ai-response-handler',
  AI_MESSAGE: 'ai-message',
  AI_MESSAGE_UPDATE: 'ai-message-update',
  ADD_USER_MESSAGE: 'add-user-message',
  ASK_AI_WITH_SELECTION: 'ask-ai-with-selection',
};

export const createEvent = <T>(eventType: string, detail: T): CustomEvent<T> => {
  return new CustomEvent(eventType, {
    detail,
    bubbles: true,
    cancelable: true,
    composed: true
  });
};

export const dispatchEvent = <T>(eventType: string, detail: T): void => {
  const event = createEvent(eventType, detail);
  window.dispatchEvent(event);
};
